import * as constants from './constants';
import { FileMeta } from './types';

export const updateFilesMeta = (files: FileMeta[]) => {
    return { type: constants.UPDATE_META, files } as const;
};
